import { useCallback } from 'react';

export const useSearchInput = (handleSearchClick: (value: string) => void) => {
    const onSearchInput = useCallback((value: string) => {
        handleSearchClick(value);
    }, [handleSearchClick]);

    return { onSearchInput };
};